export const SHOW_CUSTOMER_CARD = 'customer-ui/SHOW_CUSTOMER_CARD';
export const SHOW_CUSTOMER_SEARCH = 'customer-ui/SHOW_CUSTOMER_SEARCH';
